import Vue from 'vue'
import {options} from "./plugins/vuetify";
import App from './App.vue'
import Interceptors from './interceptors/index'

import router from './router/index'
import store from './store/index'
import './registerServiceWorker'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'
import 'font-awesome/css/font-awesome.css'
import './style/style.css'
import "vuetify-dialog/dist/vuetify-dialog.min.css";
import OAuth from './oauth'
import VuetifyDialog from 'vuetify-dialog'
import Error from "./components/Errors";
import Vuetify from "vuetify";
import * as VueGoogleMaps from 'vue2-google-maps'

//
Vue.config.productionTip = false
Vue.prototype.$oauth = new OAuth();
const vuetify = new Vuetify(options);
Vue.use(VuetifyDialog, {
    context: {
        vuetify
    }
});
Vue.component('error', Error);

Vue.use(Interceptors)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCpb54b8FB5WVxBDKAYVknsOZWGYNn0V74',
        libraries: 'places,directions', // This is required if you use the Autocomplete plugin
    },
})

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
